export default "__VITE_ASSET__BxQliesg__"